import { render } from "./SelectStaff.vue?vue&type=template&id=7821bede&scoped=true"
import script from "./SelectStaff.vue?vue&type=script&lang=js"
export * from "./SelectStaff.vue?vue&type=script&lang=js"

import "./SelectStaff.vue?vue&type=style&index=0&id=7821bede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7821bede"]])

export default __exports__